module.exports = __webpack_public_path__ + "img/11.b26cb880.png";